// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"About_wrapper__1NpN7","welcomeLine":"About_welcomeLine__416kI","text":"About_text__2WxZq","icons":"About_icons__2AWDy"};